import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import Typography from '@mui/material/Typography'
interface Props {
  count?: number
  maxCount?: number
  totalCount?: number
}

export default function UsageThisMonth({ count, maxCount, totalCount }: Props) {
  return (
    <Card variant="outlined">
      <CardContent sx={{ textAlign: 'center', px: 5 }}>
        <Typography>登録ユーザー数</Typography>
        <Typography variant="h2">
          {count}
          <span style={{ fontSize: '30px' }}>/{totalCount}</span>
        </Typography>
        <Typography variant="body1" color="text.secondary">
          最大登録数 {maxCount}
        </Typography>
      </CardContent>
    </Card>
  )
}
